/**
 * @generated SignedSource<<be67dcd83a63bd29484f0fde0dda47e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZnglistIdType = "DATABASE_ID" | "ID" | "SLUG" | "URI";
export type Znglist_Single_Short_Query$variables = {
  id: string;
  idType: ZnglistIdType;
};
export type Znglist_Single_Short_Query$data = {
  readonly znglist: {
    readonly id: string;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type Znglist_Single_Short_Query = {
  response: Znglist_Single_Short_Query$data;
  variables: Znglist_Single_Short_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "idType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "idType",
        "variableName": "idType"
      }
    ],
    "concreteType": "Znglist",
    "kind": "LinkedField",
    "name": "znglist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_Single_Short_Query",
    "selections": (v1/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Znglist_Single_Short_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d9e00315687baf3f0ba2ff125e2ea4a",
    "id": null,
    "metadata": {},
    "name": "Znglist_Single_Short_Query",
    "operationKind": "query",
    "text": "query Znglist_Single_Short_Query(\n  $id: ID!\n  $idType: ZnglistIdType!\n) {\n  znglist(id: $id, idType: $idType) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1920911a69729e285b754bb35cf376f";

export default node;
